/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BackendTypesEnum } from './BackendTypesEnum';
import {
    BackendTypesEnumFromJSON,
    BackendTypesEnumFromJSONTyped,
    BackendTypesEnumToJSON,
} from './BackendTypesEnum';
import type { FailedPackage } from './FailedPackage';
import {
    FailedPackageFromJSON,
    FailedPackageFromJSONTyped,
    FailedPackageToJSON,
} from './FailedPackage';
import type { InstalledPackage } from './InstalledPackage';
import {
    InstalledPackageFromJSON,
    InstalledPackageFromJSONTyped,
    InstalledPackageToJSON,
} from './InstalledPackage';
import type { SoftwareEnvironmentBuildStateEnum } from './SoftwareEnvironmentBuildStateEnum';
import {
    SoftwareEnvironmentBuildStateEnumFromJSON,
    SoftwareEnvironmentBuildStateEnumFromJSONTyped,
    SoftwareEnvironmentBuildStateEnumToJSON,
} from './SoftwareEnvironmentBuildStateEnum';

/**
 * 
 * @export
 * @interface SoftwareEnvironmentBuildSchema
 */
export interface SoftwareEnvironmentBuildSchema {
    /**
     * 
     * @type {number}
     * @memberof SoftwareEnvironmentBuildSchema
     */
    id: number;
    /**
     * 
     * @type {Date}
     * @memberof SoftwareEnvironmentBuildSchema
     */
    created: Date;
    /**
     * 
     * @type {Date}
     * @memberof SoftwareEnvironmentBuildSchema
     */
    updated: Date;
    /**
     * 
     * @type {boolean}
     * @memberof SoftwareEnvironmentBuildSchema
     */
    built: boolean;
    /**
     * 
     * @type {SoftwareEnvironmentBuildStateEnum}
     * @memberof SoftwareEnvironmentBuildSchema
     */
    state: SoftwareEnvironmentBuildStateEnum;
    /**
     * 
     * @type {number}
     * @memberof SoftwareEnvironmentBuildSchema
     */
    sizeBytes?: number;
    /**
     * 
     * @type {string}
     * @memberof SoftwareEnvironmentBuildSchema
     */
    reason: string;
    /**
     * 
     * @type {number}
     * @memberof SoftwareEnvironmentBuildSchema
     */
    specId: number;
    /**
     * 
     * @type {BackendTypesEnum}
     * @memberof SoftwareEnvironmentBuildSchema
     */
    backendType: BackendTypesEnum;
    /**
     * 
     * @type {Array<InstalledPackage>}
     * @memberof SoftwareEnvironmentBuildSchema
     */
    packages: Array<InstalledPackage>;
    /**
     * 
     * @type {Array<FailedPackage>}
     * @memberof SoftwareEnvironmentBuildSchema
     */
    failedPackages?: Array<FailedPackage>;
    /**
     * 
     * @type {string}
     * @memberof SoftwareEnvironmentBuildSchema
     */
    phoneHomeReason?: string;
}

/**
 * Check if a given object implements the SoftwareEnvironmentBuildSchema interface.
 */
export function instanceOfSoftwareEnvironmentBuildSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "created" in value;
    isInstance = isInstance && "updated" in value;
    isInstance = isInstance && "built" in value;
    isInstance = isInstance && "state" in value;
    isInstance = isInstance && "reason" in value;
    isInstance = isInstance && "specId" in value;
    isInstance = isInstance && "backendType" in value;
    isInstance = isInstance && "packages" in value;

    return isInstance;
}

export function SoftwareEnvironmentBuildSchemaFromJSON(json: any): SoftwareEnvironmentBuildSchema {
    return SoftwareEnvironmentBuildSchemaFromJSONTyped(json, false);
}

export function SoftwareEnvironmentBuildSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): SoftwareEnvironmentBuildSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'created': (new Date(json['created'])),
        'updated': (new Date(json['updated'])),
        'built': json['built'],
        'state': SoftwareEnvironmentBuildStateEnumFromJSON(json['state']),
        'sizeBytes': !exists(json, 'size_bytes') ? undefined : json['size_bytes'],
        'reason': json['reason'],
        'specId': json['spec_id'],
        'backendType': BackendTypesEnumFromJSON(json['backend_type']),
        'packages': ((json['packages'] as Array<any>).map(InstalledPackageFromJSON)),
        'failedPackages': !exists(json, 'failed_packages') ? undefined : ((json['failed_packages'] as Array<any>).map(FailedPackageFromJSON)),
        'phoneHomeReason': !exists(json, 'phone_home_reason') ? undefined : json['phone_home_reason'],
    };
}

export function SoftwareEnvironmentBuildSchemaToJSON(value?: SoftwareEnvironmentBuildSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'created': (value.created.toISOString()),
        'updated': (value.updated.toISOString()),
        'built': value.built,
        'state': SoftwareEnvironmentBuildStateEnumToJSON(value.state),
        'size_bytes': value.sizeBytes,
        'reason': value.reason,
        'spec_id': value.specId,
        'backend_type': BackendTypesEnumToJSON(value.backendType),
        'packages': ((value.packages as Array<any>).map(InstalledPackageToJSON)),
        'failed_packages': value.failedPackages === undefined ? undefined : ((value.failedPackages as Array<any>).map(FailedPackageToJSON)),
        'phone_home_reason': value.phoneHomeReason,
    };
}

